import { EleveViewFilter, FilterGroup } from '@teetsh/app/src/types/eleves';
import { FilterGroupAPI } from '@teetsh/app/src/queries/eleves/views/types';

export default function deserializeFilter(
  filters: FilterGroupAPI,
): FilterGroup | undefined {
  if (!filters) {
    return undefined;
  }
  const filterSet: EleveViewFilter[] = [];
  (filters?.filterSet || []).forEach(filter => {
    filterSet.push({
      id: filter.id,
      value: filter.value,
      columnId: filter.columnId || filter.customFieldId || '',
      operator: filter.operator,
    });
  });
  return {
    id: filters.id,
    filterSet,
  };
}
